// LocalStorage-backed bookmarks. Will migrate to server per-user when auth ships.
const KEY = "ktb_bookmarks_v1";

export function readAll() {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
}

function writeAll(list) {
  localStorage.setItem(KEY, JSON.stringify(list));
  window.dispatchEvent(new Event("ktb-bookmarks-changed"));
}

function keyOf(v) { return `${v.book_name}|${v.chapter}|${v.verse}|${v.translation_id || "kjv"}`; }

export function isBookmarked(v) {
  return readAll().some((b) => b.key === keyOf(v));
}

export function toggle(v) {
  const list = readAll();
  const k = keyOf(v);
  const i = list.findIndex((b) => b.key === k);
  if (i >= 0) {
    list.splice(i, 1);
    writeAll(list);
    return false;
  }
  list.unshift({
    key: k,
    book_name: v.book_name,
    chapter: v.chapter,
    verse: v.verse,
    text: v.text.trim(),
    translation: v.translation_id || "kjv",
    saved_at: new Date().toISOString(),
  });
  writeAll(list);
  return true;
}

export function remove(key) {
  writeAll(readAll().filter((b) => b.key !== key));
}
